/**
 * Language configuration constants for the application
 */

/**
 * Default language for the application
 */
export const DEFAULT_LANG = 'en'

/**
 * List of supported languages in the application
 */
export const SUPPORTED_LANGS = ['en', 'es', 'el', 'ro', 'sl']
/**
 * Key used to store user language preference in localStorage
 */
export const USER_LANG_KEY = 'lang'
